import _ from "lodash";

export const getSteps = (player) => {
    return ((Object.entries(player).filter((key)=>{
        return /^[pP][1-9][0-9]*/g.test(key[0]);
    })))
}


export const getCurrentPoint = (player) => {
    let nextPoint = getSteps(player)[0]
    nextPoint = _.findLast(Object.entries(player),(key)=> {
        if(/^[pP][1-9][0-9]*/.test( key[0])) {
            return !!key[1];
        }
        return false
    })
    const firstPoint = _.find(Object.entries(player),(key)=> {
        return /^[pP][1-9][0-9]*/.test(key[0]);

    })
    return (nextPoint!==undefined) ? nextPoint[0] : firstPoint[0]
}
